import { Organization } from '../../../../features/organization-list/domain/organisation.model';
import { some, none } from '@hereisyourgitanton/core';
import { OrganizationResponseDto, OrganizationStatusEnum } from '@tradgine/data-access/tradgine-data';

export function toOrganization(dto: OrganizationResponseDto): Organization {
    return {
        id: dto.id,
        name: dto.name ?? '',
        taxIdentificationNumber: dto.taxIdentificationNumber ? some(dto.taxIdentificationNumber) : none(),
        legalAddress: dto.legalAddress ? some(dto.legalAddress) : none(),
        phoneNumber: dto.phoneNumber ? some(dto.phoneNumber) : none(),
        email: dto.email ? some(dto.email) : none(),
        status: toStatus(dto.status),
        logoUrl: dto.logoUrl ? some(dto.logoUrl) : none(),
        organizationType: dto.organizationTypeName ? some(dto.organizationTypeName) : none(),
        functionalType: dto.functionalType ? some(dto.functionalType) : none(),
        createdDateTime: dto.createdDateTime
    }
}

function toStatus(status: OrganizationStatusEnum): Organization['status'] {
    switch (status) {
        case OrganizationStatusEnum.Active:
            return 'active';
        case OrganizationStatusEnum.PendingVerification:
            return 'pendingVerification';
        case OrganizationStatusEnum.Archived:
            return 'archived';
        case OrganizationStatusEnum.Blocked:
            return 'blocked';
        default:
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            { const _ignored: never = status; // Ensure all cases are handled
            return 'unknown' }
    }
}
